/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Ogimagealt2Inputs */

const id_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games`)
};

const ms_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalan Data Epic Games`)
};

const da_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database`)
};

const de_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Datenbank`)
};

const en_us2_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database`)
};

const es_es2_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos de Epic Games`)
};

const es_mx2_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de datos de Epic Games`)
};

const fil_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database`)
};

const fr_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de données Epic Games`)
};

const it_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Database Epic Games`)
};

const hu_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Adatbázis`)
};

const nl_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database`)
};

const no_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Database`)
};

const pl_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza danych Epic Games`)
};

const pt_br2_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de dados da Epic Games`)
};

const pt_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base de Dados Epic Games`)
};

const ro_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baza de date Epic Games`)
};

const fi_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games -tietokanta`)
};

const sv_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games-databas`)
};

const vi_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cơ sở dữ liệu Epic Games`)
};

const tr_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games Veritabanı`)
};

const cs_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Databáze Epic Games`)
};

const bg_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данни на Epic Games`)
};

const ru_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База данных Epic Games`)
};

const uk_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`База даних Epic Games`)
};

const ar_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعدة بيانات Epic Games`)
};

const hi_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games डेटाबेस`)
};

const th_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานข้อมูล Epic Games`)
};

const ja_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games データベース`)
};

const zh_cn2_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic游戏数据库`)
};

const zh_hant1_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic遊戲資料庫`)
};

const ko_meta_ogimagealt2 = /** @type {(inputs: Meta_Ogimagealt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epic Games 데이터베이스`)
};

/**
* | output |
* | --- |
* | "Epic Games Database" |
*
* @param {Meta_Ogimagealt2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const meta_ogimagealt2 = /** @type {((inputs?: Meta_Ogimagealt2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Ogimagealt2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_meta_ogimagealt2(inputs)
	if (locale === "ms") return ms_meta_ogimagealt2(inputs)
	if (locale === "da") return da_meta_ogimagealt2(inputs)
	if (locale === "de") return de_meta_ogimagealt2(inputs)
	if (locale === "en-US") return en_us2_meta_ogimagealt2(inputs)
	if (locale === "es-ES") return es_es2_meta_ogimagealt2(inputs)
	if (locale === "es-MX") return es_mx2_meta_ogimagealt2(inputs)
	if (locale === "fil") return fil_meta_ogimagealt2(inputs)
	if (locale === "fr") return fr_meta_ogimagealt2(inputs)
	if (locale === "it") return it_meta_ogimagealt2(inputs)
	if (locale === "hu") return hu_meta_ogimagealt2(inputs)
	if (locale === "nl") return nl_meta_ogimagealt2(inputs)
	if (locale === "no") return no_meta_ogimagealt2(inputs)
	if (locale === "pl") return pl_meta_ogimagealt2(inputs)
	if (locale === "pt-BR") return pt_br2_meta_ogimagealt2(inputs)
	if (locale === "pt") return pt_meta_ogimagealt2(inputs)
	if (locale === "ro") return ro_meta_ogimagealt2(inputs)
	if (locale === "fi") return fi_meta_ogimagealt2(inputs)
	if (locale === "sv") return sv_meta_ogimagealt2(inputs)
	if (locale === "vi") return vi_meta_ogimagealt2(inputs)
	if (locale === "tr") return tr_meta_ogimagealt2(inputs)
	if (locale === "cs") return cs_meta_ogimagealt2(inputs)
	if (locale === "bg") return bg_meta_ogimagealt2(inputs)
	if (locale === "ru") return ru_meta_ogimagealt2(inputs)
	if (locale === "uk") return uk_meta_ogimagealt2(inputs)
	if (locale === "ar") return ar_meta_ogimagealt2(inputs)
	if (locale === "hi") return hi_meta_ogimagealt2(inputs)
	if (locale === "th") return th_meta_ogimagealt2(inputs)
	if (locale === "ja") return ja_meta_ogimagealt2(inputs)
	if (locale === "zh-CN") return zh_cn2_meta_ogimagealt2(inputs)
	if (locale === "zh-Hant") return zh_hant1_meta_ogimagealt2(inputs)
	return ko_meta_ogimagealt2(inputs)
});
export { meta_ogimagealt2 as "meta.ogImageAlt" }